const BodyLogo = () => {
  return (
    <div className="w-7 h-7 flex items-center justify-center ml-2">
      <svg viewBox="0 0 203 203" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0H53.9846V149.015H0V0Z" fill="url(#paint0_linear_134_4)" />
        <path
          d="M149.017 0V53.9846H0.00140381V0H149.017Z"
          fill="url(#paint1_linear_134_4)"
        />
        <path
          d="M203 203H149.015V53.9846H203V203Z"
          fill="url(#paint2_linear_134_4)"
        />
        <path
          d="M53.9832 203V149.015H202.999V203H53.9832Z"
          fill="url(#paint3_linear_134_4)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_134_4"
            x1="53.9834"
            y1="176.008"
            x2="202.999"
            y2="176.008"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2A9D8F" />
            <stop offset="1" stopColor="#264653" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_134_4"
            x1="53.9834"
            y1="176.008"
            x2="202.999"
            y2="176.008"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2A9D8F" />
            <stop offset="1" stopColor="#264653" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_134_4"
            x1="53.9834"
            y1="176.008"
            x2="202.999"
            y2="176.008"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2A9D8F" />
            <stop offset="1" stopColor="#264653" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_134_4"
            x1="53.9834"
            y1="176.008"
            x2="202.999"
            y2="176.008"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2A9D8F" />
            <stop offset="1" stopColor="#264653" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default BodyLogo;
